(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wbp-frame-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wbp-frame-preview')) {
  customElements.define('wbp-frame-preview', class WbpFramePreview extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.productRoot = this.closest('.product') || document;
      this.frameButtons = Array.from(this.querySelectorAll('[data-frame-option]'));
      this.productForm = null;
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-preview-open]');
      this.closeButton = this.querySelector('[data-preview-close]');
      this.stages = Array.from(this.querySelectorAll('[data-preview-stage]'));
      this.artworks = Array.from(this.querySelectorAll('[data-artwork]'));
      this.legacyGroups = new Set();
      this.handleChange = this.handleChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleDialogClick = this.handleDialogClick.bind(this);
      this.handleFormData = this.handleFormData.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.legacyTimers = [];

      this.frameButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectFrame(button));
      });

      this.openButton?.addEventListener('click', () => {
        if (!this.dialog) return;
        this.dialog.showModal();
        requestAnimationFrame(() => this.layout());
      });

      this.closeButton?.addEventListener('click', () => this.dialog?.close());
      this.dialog?.addEventListener('click', this.handleDialogClick);
      document.addEventListener('change', this.handleChange);
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.connectProductForm();

      this.restoreFrameChoice();
      this.replaceLegacyFinish();
      this.scheduleLegacyFinishChecks();
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.handleChange);
      window.removeEventListener('resize', this.handleResize);
      this.productForm?.removeEventListener('formdata', this.handleFormData);
      this.productForm?.removeEventListener('submit', this.handleSubmit, true);
      this.orderProperty?.remove();
      this.dialog?.removeEventListener('click', this.handleDialogClick);
      this.legacyTimers.forEach((timer) => clearTimeout(timer));
      this.legacyGroups.forEach((group) => {
        if (group.isConnected) group.classList.remove('wbp-frame-preview__legacy-finish');
      });
      this.legacyGroups.clear();
    }

    handleChange(event) {
      if (!this.productRoot.contains(event.target)) return;
      this.update();
      this.scheduleLegacyFinishChecks([0, 500]);
    }

    handleResize() {
      this.scheduleLayout();
    }

    connectProductForm() {
      const form = document.getElementById(this.dataset.formId);
      if (!form || form === this.productForm) return;
      this.productForm?.removeEventListener('formdata', this.handleFormData);
      this.productForm?.removeEventListener('submit', this.handleSubmit, true);
      this.productForm = form;
      this.productForm.addEventListener('formdata', this.handleFormData);
      this.productForm.addEventListener('submit', this.handleSubmit, true);
      this.dataset.formConnected = 'true';
    }

    getSelectedFrameValue() {
      const selectedButton = this.frameButtons.find((button) => button.getAttribute('aria-pressed') === 'true');
      return selectedButton?.dataset.frameValue || '';
    }

    handleSubmit() {
      this.orderProperty?.remove();
      this.orderProperty = null;
      if (!this.isFramedSelected() || !this.productForm) return;

      this.orderProperty = document.createElement('input');
      this.orderProperty.type = 'hidden';
      this.orderProperty.name = 'properties[Frame colour]';
      this.orderProperty.value = this.getSelectedFrameValue();
      this.orderProperty.dataset.wbpOrderProperty = '';
      this.productForm.append(this.orderProperty);
    }

    handleFormData(event) {
      const propertyName = 'properties[Frame colour]';
      if (!this.isFramedSelected()) {
        event.formData.delete(propertyName);
        return;
      }

      const frameValue = this.getSelectedFrameValue();
      if (frameValue) event.formData.set(propertyName, frameValue);
    }

    handleDialogClick(event) {
      if (event.target === this.dialog) this.dialog.close();
    }

    getSelectedOption(name) {
      const radios = Array.from(this.productRoot.querySelectorAll('input[type="radio"]'));
      const checkedRadio = radios.find((input) => input.name === name && input.checked);
      if (checkedRadio) return checkedRadio.value;

      const selects = Array.from(this.productRoot.querySelectorAll('select'));
      const selected = selects.find((select) => select.name === name || select.getAttribute('data-option-name') === name);
      return selected?.value || '';
    }

    isFramedSelected() {
      const selectedFinish = this.getSelectedOption('Print Option') || this.getSelectedOption('Finish');
      return selectedFinish.trim().toLowerCase() === 'framed';
    }

    restoreFrameChoice() {
      let savedValue = '';
      try {
        savedValue = sessionStorage.getItem(`wbp-frame-${this.dataset.productId}`) || '';
      } catch (error) {
        savedValue = '';
      }

      const matchingButton = this.frameButtons.find((button) => button.dataset.frameValue === savedValue);
      this.selectFrame(matchingButton || this.frameButtons[0], false);
    }

    selectFrame(button, save = true) {
      if (!button) return;
      this.frameButtons.forEach((option) => {
        option.setAttribute('aria-pressed', String(option === button));
      });
      this.dataset.frame = button.dataset.frameOption || 'white';
      const frameValue = button.dataset.frameValue || 'White Open Grain';

      if (save) {
        try {
          sessionStorage.setItem(`wbp-frame-${this.dataset.productId}`, frameValue);
        } catch (error) {
          this.dataset.storageUnavailable = 'true';
        }
      }

      this.updateLabels();
      this.replaceLegacyFinish();
    }

    replaceLegacyFinish() {
      const legacyInputs = Array.from(this.productRoot.querySelectorAll('input[name="Frame Finish"]'));
      legacyInputs.forEach((input) => {
        const group = input.closest('.gpo-element') || input.closest('.gpo-group') || input.parentElement;
        if (group) {
          this.legacyGroups.add(group);
          group.classList.add('wbp-frame-preview__legacy-finish');
        }
      });

      if (!this.isFramedSelected()) return;
      const frameValue = this.getSelectedFrameValue();
      const targetInput = legacyInputs.find((input) => input.value === frameValue);
      if (targetInput && !targetInput.checked && !targetInput.disabled) targetInput.click();
    }

    scheduleLegacyFinishChecks(delays = [0, 400, 1200, 2600]) {
      delays.forEach((delay) => {
        const timer = setTimeout(() => {
          this.connectProductForm();
          this.replaceLegacyFinish();
          this.legacyTimers = this.legacyTimers.filter((item) => item !== timer);
        }, delay);
        this.legacyTimers.push(timer);
      });
    }

    update() {
      const framed = this.isFramedSelected();
      this.hidden = !framed;
      if (!framed) return;
      this.updateLabels();
      this.scheduleLayout();
    }

    updateLabels() {
      const size = this.getSelectedOption('Size') || this.dataset.defaultSize;
      const selectedButton = this.frameButtons.find((button) => button.getAttribute('aria-pressed') === 'true');
      const frameLabel = selectedButton?.querySelector('[data-option-label]')?.textContent.trim() || '';
      const frameValue = selectedButton?.dataset.frameValue || '';

      this.querySelectorAll('[data-size-badge], [data-size-label]').forEach((element) => {
        element.textContent = size;
      });
      this.querySelectorAll('[data-frame-label]').forEach((element) => {
        element.textContent = frameLabel;
      });

      const ariaLabel = (this.dataset.ariaTemplate || '')
        .replace('__IMAGE__', this.dataset.photoLabel || '')
        .replace('__FRAME__', frameValue)
        .replace('__SIZE__', size);
      this.artworks.forEach((artwork) => artwork.setAttribute('aria-label', ariaLabel));
    }

    scheduleLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => this.layout());
    }

    parseSize() {
      const size = this.getSelectedOption('Size') || this.dataset.defaultSize;
      const match = size.match(/([0-9]+(?:\.[0-9]+)?)\s*(?:x|×)\s*([0-9]+(?:\.[0-9]+)?)/i);
      const imageWidth = Number(this.dataset.imageWidth) || 3;
      const imageHeight = Number(this.dataset.imageHeight) || 2;
      const imageIsLandscape = imageWidth >= imageHeight;

      let width = match ? Number(match[1]) : 12;
      let height = match ? Number(match[2]) : 8;
      if (imageIsLandscape && width < height) [width, height] = [height, width];
      if (!imageIsLandscape && width > height) [width, height] = [height, width];
      return { width, height };
    }

    layout() {
      if (this.hidden) return;
      const photo = this.parseSize();
      const mountInches = 2;
      const frameMillimetres = 35;
      const frameInches = frameMillimetres / 25.4;
      const outerWidth = photo.width + (mountInches + frameInches) * 2;
      const outerHeight = photo.height + (mountInches + frameInches) * 2;

      this.artworks.forEach((artwork) => {
        const stage = artwork.closest('[data-preview-stage]');
        if (!stage || stage.clientWidth === 0 || stage.clientHeight === 0) return;
        const isDialog = stage.classList.contains('wbp-frame-preview__stage--dialog');
        const horizontalAllowance = isDialog ? 60 : 30;
        const verticalAllowance = isDialog ? 60 : 82;
        const availableWidth = Math.max(140, stage.clientWidth - horizontalAllowance);
        const availableHeight = Math.max(170, stage.clientHeight - verticalAllowance);
        const scale = Math.min(availableWidth / outerWidth, availableHeight / outerHeight);
        const framePixels = Math.max(6, frameInches * scale);
        const mountPixels = Math.max(10, mountInches * scale);

        artwork.style.width = `${outerWidth * scale}px`;
        artwork.style.height = `${outerHeight * scale}px`;
        artwork.style.setProperty('--wbp-frame-width', `${framePixels}px`);
        artwork.style.setProperty('--wbp-mount-width', `${mountPixels}px`);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
